import { useState, useEffect } from 'react';
import '../../../entrydoor.css';

// SillSize — shown when SillType is selected; default 6 5/8"
const OPTIONS = [
  { value: '4 5/8"',  label: '4 5/8"'  },
  { value: '5 3/4"',  label: '5 3/4"'  },
  { value: '6 5/8"',  label: '6 5/8"'  },
  { value: '7 1/4"',  label: '7 1/4"'  },
  { value: '7 3/4"',  label: '7 3/4"'  },
  { value: '8 5/8"',  label: '8 5/8"'  },
  { value: '9 3/4"',  label: '9 3/4"'  },
  { value: '10 5/8"', label: '10 5/8"' },
];

const SillSize = ({ value = { value: '6 5/8"', label: '6 5/8"' }, onChange, disabled = false }) => {
  const [selected, setSelected] = useState(value?.value || '6 5/8"');

  useEffect(() => { setSelected(value?.value || '6 5/8"'); }, [value?.value]);

  const handleChange = (e) => {
    const v = e.target.value;
    const label = OPTIONS.find(o => o.value === v)?.label || v;
    setSelected(v);
    onChange({ value: v, label });
  };

  return (
    <div className="a-container">
      <label htmlFor="SdSillSize">Sill Size</label>
      <select id="SdSillSize" value={selected} onChange={handleChange} disabled={disabled}>
        {OPTIONS.map(o => (
          <option key={o.value} value={o.value}>
            {selected === o.value ? `${o.label} ✔` : o.label}
          </option>
        ))}
      </select>
    </div>
  );
};

export default SillSize;
